<template>
  <div class="food-recipe-page">
    <div class="recipe-hero">
      <button class="back-button" type="button" @click="goBack">
        <van-icon name="arrow-left" />
      </button>
      <img v-if="food.image" :src="food.image" :alt="food.name" referrerpolicy="no-referrer">
      <div v-else class="recipe-placeholder">{{ food.name.slice(0, 1) }}</div>
    </div>

    <main class="recipe-content">
      <section class="recipe-title">
        <span>{{ food.task_title || '辅食制作' }}</span>
        <h1>{{ food.name }}</h1>
        <div v-if="food.tags && food.tags.length" class="recipe-tags">
          <van-tag v-for="tag in food.tags" :key="tag" color="#FFF7E8" text-color="#B46B12">{{ tag }}</van-tag>
        </div>
      </section>

      <section v-if="food.ingredients" class="recipe-section">
        <h2>准备食材</h2>
        <p>{{ food.ingredients }}</p>
      </section>

      <section v-if="food.description || food.desc || food.reason" class="recipe-section">
        <h2>制作提示</h2>
        <p>{{ food.description || food.desc || food.reason }}</p>
      </section>

      <section v-if="food.steps" class="recipe-section">
        <h2>制作步骤</h2>
        <p>{{ food.steps }}</p>
      </section>

      <section v-if="food.tips" class="recipe-section">
        <h2>注意事项</h2>
        <p>{{ food.tips }}</p>
      </section>

      <section class="recipe-section">
        <h2>添加建议</h2>
        <p>从少量开始，观察宝宝接受度和皮肤、排便等反应。首次尝试建议单一食材，确认适应后再组合添加。</p>
      </section>
    </main>

    <div class="bottom-action">
      <button type="button" @click="openNativeFood">添加辅食</button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'TcmFoodRecipe',
    data () {
        return {
            food: {
                name: '辅食推荐',
                image: '',
                tags: []
            }
        };
    },
    created () {
        this.food = this.parseFood();
    },
    methods: {
        parseFood () {
            const raw = this.$route.query.food;
            if (!raw) {
                return { name: '辅食推荐', image: '', tags: [] };
            }
            try {
                const parsed = JSON.parse(decodeURIComponent(raw));
                return {
                    ...parsed,
                    name: parsed.name || '辅食推荐',
                    image: parsed.image || '',
                    steps: parsed.steps || '',
                    tips: parsed.tips || '',
                    tags: Array.isArray(parsed.tags) ? parsed.tags : []
                };
            } catch (error) {
                return { name: '辅食推荐', image: '', tags: [] };
            }
        },
        goBack () {
            const target = {
                path: this.$route.query.return_path || '/tcm-study/home',
                query: {
                    ...this.$route.query,
                    food: undefined
                }
            };
            this.$router.replace(target);
        },
        openNativeFood () {
            const payload = {
                source: 'tcm-study',
                target: 'complementary-food-record',
                native_route: 'record.baby.food',
                tab: 'record',
                module: 'baby_record_food',
                record_date: this.$route.query.record_date,
                date: this.$route.query.record_date,
                baby_id: this.$route.query.baby_id,
                subject_id: this.$route.query.subject_id,
                task_key: this.food.task_key,
                task_title: this.food.task_title,
                recommendation: this.food,
                recommendations: [this.food],
                allow_makeup: true
            };
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openComplementaryFoodRecord) {
                window.webkit.messageHandlers.openComplementaryFoodRecord.postMessage(payload);
                return;
            }
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.openFoodRecord) {
                window.webkit.messageHandlers.openFoodRecord.postMessage(payload);
                return;
            }
            if (window.healthApp && typeof window.healthApp.openComplementaryFoodRecord === 'function') {
                window.healthApp.openComplementaryFoodRecord(payload);
                return;
            }
            if (window.healthApp && typeof window.healthApp.openFoodRecord === 'function') {
                window.healthApp.openFoodRecord(payload);
                return;
            }
            this.$toast('请返回 App 使用现有辅食记录入口');
        }
    }
};
</script>

<style scoped lang="sass">
.food-recipe-page
    min-height: 100vh
    padding-bottom: calc(84px + env(safe-area-inset-bottom))
    background: #f7f8f5
    color: #24312e

.recipe-hero
    position: relative
    height: 220px
    padding-top: max(12px, env(safe-area-inset-top))
    background: #fff3d8
    overflow: hidden

.recipe-hero img,
.recipe-placeholder
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    object-fit: cover
    color: #2e8b7a
    font-size: 56px
    font-weight: 700

.back-button
    position: absolute
    z-index: 2
    left: 12px
    top: max(12px, env(safe-area-inset-top))
    width: 36px
    height: 36px
    border: 0
    border-radius: 18px
    background: rgba(255, 255, 255, .92)
    color: #263331
    display: flex
    align-items: center
    justify-content: center

.recipe-content
    padding: 16px

.recipe-title
    padding: 14px 0 6px

.recipe-title span
    color: #2e8b7a
    font-size: 12px
    line-height: 17px

.recipe-title h1
    margin: 4px 0 10px
    color: #24312e
    font-size: 22px
    line-height: 30px
    font-weight: 700

.recipe-tags
    display: flex
    flex-wrap: wrap
    gap: 6px

.recipe-section
    margin-top: 12px
    padding: 14px
    border-radius: 8px
    background: #ffffff
    border: 1px solid #edf2ef

.recipe-section h2
    margin: 0 0 8px
    color: #263331
    font-size: 15px
    line-height: 21px
    font-weight: 700

.recipe-section p
    margin: 0
    color: #5f6b67
    font-size: 13px
    line-height: 21px
    white-space: pre-line

.bottom-action
    position: fixed
    left: 0
    right: 0
    bottom: 0
    padding: 10px 16px calc(10px + env(safe-area-inset-bottom))
    background: rgba(255, 255, 255, .96)
    border-top: 1px solid #edf2ef

.bottom-action button
    width: 100%
    min-height: 44px
    border: 0
    border-radius: 8px
    background: #2e8b7a
    color: #ffffff
    font-size: 15px
    line-height: 21px
    font-weight: 700
</style>
